import o from "./ghl-ui.es823.js";
import r from "./ghl-ui.es824.js";
import e from "./ghl-ui.es389.js";
function p(t) {
  return typeof t.constructor == "function" && !e(t) ? o(r(t)) : {};
}
export {
  p as default
};
